import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useAddFavourite = ({ onSuccess }: { onSuccess: () => void }) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: { name: string; url: string }) =>
      httpService.panel.panelUsersSavedLinksCreate(data),
    onSuccess
  })

export default useAddFavourite
